import React from "react";
import { useNavigate } from "react-router-dom";
import "./HeaderNaoLogado.css";
import logo from '../../assets/Logo-branco.png'

function HeaderNaoLogado() {
    const navigate = useNavigate();
    return (
        <header className="header">
            <div className="header-logo">
                <img src={logo} alt="Logo" onClick={() => window.location.href = 'https://app.institutoselmacosso.com.br'}/>
            </div>
            <button className="header-login-button" onClick={() => navigate('/login')}>Login</button>
        </header>
    );
}

export default HeaderNaoLogado;
